
<div class="table-cell-stacked">
  <div class="table-cell-stacked__primary">
    <slot name="primary">{{ primary }}</slot>
  </div>
  <div v-if="secondary || $slots.secondary" class="table-cell-stacked__secondary">
    <slot name="secondary">{{ secondary }}</slot>
  </div>
</div>
